/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

interface Props {
  className?: string;
}

export const Variant1_1 = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="41"
      viewBox="0 0 41 41"
      width="41"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25439 20.5002C8.25439 29.3019 15.4154 36.4629 24.2176 36.4629C24.3986 36.4629 24.5457 36.3162 24.5457 36.1347V4.86472C24.5457 4.68373 24.3986 4.53656 24.2176 4.53656C15.4154 4.537 8.25439 11.6984 8.25439 20.5002Z"
        fill="white"
      />
    </svg>
  );
};
